<template>
    <b-modal
        id="repereModal"
        v-model="repereModal"
        size="xxl"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="green"
        body-bg-variant="green"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body" style="min-height: 350px">
            <div class="close-button" @click="$emit('hideTempModal');">X</div>
            <div class="modal-body-content">
                <img src="@/assets/images/M3/M3Sketch/reper-hero.png" class="hero-picture" alt="">
                <div class="empty-left"></div>
                <div class="reper-info">
                    <h2 class="reper-title"><strong>Salvează reperul</strong> în contul tău <strong>Smis<sup style="font-size: 13px; top: -15px;">®</sup></strong></h2>
                    <p>Funcția de salvare reper îți permite să adaugi această cheltuială <strong>în orice alt proiect</strong>
                        al unei alte companii asociate contului tău. Astfel, economisești timp dacă dorești
                        să adaugi această cheltuială din nou. Tot ce trebuie să faci este să îi atribui un nume și să faci click pe <strong>salvează</strong>.
                    </p>
                    <b-form-group
                        id="fieldset-horizontal"
                        label-cols-lg="3"
                        content-cols-lg="9"
                        label="Numele reperului tău"
                        class="custom-input"
                    >
                        <b-form-input
                            v-model="title"
                            placeholder="ex: Servicii de consultanță"
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                    <div class="bottom-info">
                        <div class="app-title-group">
                            <p class="app-title">Începând cu acest an, ne porți cu tine peste tot!</p>
                            <p class="app-subtitle"><strong>Lansăm SmisApp<sup style="font-size: 13px; top: -9px;">®</sup></strong></p>
                        </div>
                        <div class="yellow-button-save" @click="saveSpending()"><strong>Salvează reperul</strong></div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconTrash, BFormTextarea, BFormFile, BIconUpload} from 'bootstrap-vue';
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
        },
        props: {
            repereModal: {
                type: Boolean,
                default: false
            },
            spending: {
                type:Object,
                default: null
            },
            files: {
                type:Object,
                default: null
            }
        },
        data() {
            return {
                title: ''
            };
        },
        mounted() {
        },
        methods: {
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },

            saveSpending() {
                if(! this.title) {
                    this.$toast.error('Numele reperului este obligatoriu');
                    return;
                }

                let formData = new FormData;

                formData.append('contribution_percentage', this.spending.subcategories.acquisitions.contribution_percentage ? this.spending.subcategories.acquisitions.contribution_percentage : null)
                formData.append('vat', this.spending.subcategories.acquisitions.cota_tva ? this.spending.subcategories.acquisitions.cota_tva : null)
                formData.append('contract_type', this.spending.subcategories.acquisitions.tip_contract ? this.spending.subcategories.acquisitions.tip_contract : null)
                formData.append('cpv', this.spending.subcategories.acquisitions.cpv ? this.spending.subcategories.acquisitions.cpv : null)
                formData.append('first_year_percentage', this.spending.subcategories.acquisitions.first_year_percentage)
                formData.append('second_year_percentage', this.spending.subcategories.acquisitions.second_year_percentage)
                formData.append('activity', this.spending.subcategories.acquisitions.activitatea_proiectului ? this.spending.subcategories.acquisitions.activitatea_proiectului : null)
                formData.append('subactivity', this.spending.subcategories.acquisitions.subactivitatea_proiectului ? this.spending.subcategories.acquisitions.subactivitatea_proiectului : null)
                formData.append('offer_1', this.spending.subcategories.acquisitions.offer_1 ? this.spending.subcategories.acquisitions.offer_1.id : null)
                formData.append('offer_1_reg_no', this.spending.subcategories.acquisitions.offer_1_reg_no ? this.spending.subcategories.acquisitions.offer_1_reg_no : null)
                formData.append('offer_2', this.spending.subcategories.acquisitions.offer_2 ? this.spending.subcategories.acquisitions.offer_2.id : null)
                formData.append('offer_2_reg_no', this.spending.subcategories.acquisitions.offer_2_reg_no ? this.spending.subcategories.acquisitions.offer_2_reg_no : null)
                formData.append('um', this.spending.subcategories.acquisitions.um ? this.spending.subcategories.acquisitions.um : null)
                formData.append('qty', this.spending.subcategories.acquisitions.cantitate ? this.spending.subcategories.acquisitions.cantitate : null)
                formData.append('category_no', this.spending.category_no ? this.spending.category_no : null)
                formData.append('subcategory_no', this.spending.subcategories.subcategory_no ? this.spending.subcategories.subcategory_no : null)
                formData.append('display_price', parseInt(this.spending.subcategories.acquisitions.pret_unitar_cu_tva))
                formData.append('title', this.title ? this.title : null)
                formData.append('description', this.spending.subcategories.acquisitions.description ? this.spending.subcategories.acquisitions.description : null)
                formData.append('justification', this.spending.subcategories.acquisitions.justificare ? this.spending.subcategories.acquisitions.justificare : null)
                formData.append('offer_1_file', this.files ? this.files.file1 : null)
                formData.append('offer_2_file', this.files ? this.files.file2 : null)
                axios.post(api.API_ENDPOINTS.m3UserSpendings, formData).then((response) => {
                    this.title = '';
                    this.$toast.success(response.data.message);
                    this.$emit('updateFiles', response.data.added_spending);
                    this.$emit('saveSpending');
                    this.$emit('hideTempModal');
                });
            }
        },
    };
</script>

<style>
#repereModal >>> .modal-content {
    background-color: transparent;
}
#repereModal >>> .modal-xxl {
    height: calc(100% - 100px);
}

#repereModal >>> .modal-xl {
    max-width: 1640px;
}

#repereModal___BV_modal_backdrop_ {
    background-color: transparent !important;
}

#opacityNone .modal-dialog {
    opacity: 0 !important;
}

#repereModal >>> .modal-dialog .bg-dark {
    background-color: rgba(49, 196, 170, 0.7) !important;
    border: rgba(49, 196, 170, 0.7) !important;
    backdrop-filter: blur(7px);
    position: relative;
    max-height: 830px;
    overflow: auto;
    height: 85vh;
    padding: 30px;
}

#repereModal >>> .modal-dialog .dark-transparent {
    background-color: rgba(49, 196, 170, 0.7) !important;
    border: rgba(49, 196, 170, 0.7) !important;
    backdrop-filter: blur(7px);
    position: relative;
    max-height: 830px;
    overflow: auto;
    height: 85vh;
    padding: 30px;
}

#repereModal >>> .modal-dialog .opacityNone {
    background-color: rgba(49, 196, 170, 0.7) !important;
    border: none !important;
    position: relative;
}

#repereModal >>> .modal-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;

}
#repereModal .modal-content {
    background-color: rgba(49, 196, 170, 0.9) !important;
    border: 4px solid #fff;
    padding: 25px;
    min-height: 540px;
}
</style>
<style scoped>
.modal-body{
    min-height: 540px;
    padding: 0;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.close-button {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 999;
}
.modal-body-content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-height: 540px;
}
.hero-picture{
    position: absolute;
    left: -21px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 0;
}
.reper-title{
    font-size: 29px;
    color: #fff;
    text-align: center;
}
.reper-info{
    max-width: 960px;
    z-index: 9;
}
.reper-info p{
    font-size: 19px;
    font-weight: 500;
    color: #fff;
    margin-top: 50px;
    margin-bottom: 20px;
}
.custom-input{
    max-width: 900px;
}
.bottom-info{
    max-width: 890px;
    margin: 0 0 0 auto;
}
.custom-input >>> legend{
    font-size: 12px;
    color: #fff;
    font-weight: 600;
}
.custom-input >>> input{
    border: none;
    border-radius: 4px;
    color: #a1dad0;
    font-size: 16px;
    font-weight: 500;
}
.custom-input >>> input::placeholder{
    color: #a1dad0;
    font-size: 16px;
    font-weight: 500;
}
.app-title-group{
    margin-top: 60px;
}
.app-title{
    font-size: 15px !important;
    margin: 0 !important;
}
.app-subtitle{
    font-size: 25px !important;
    margin: 0 !important;
}
.bottom-info{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
}
.yellow-button-save{
    background: #ffea00;
    border: 1px solid #ffea00;
    color: #000;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    padding: 6px 30px;
    width: 100%;
    max-width: 220px;
    position: relative;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.4s;
}
.yellow-button-save:hover{
    background: #f1dd03;
    border-color: #f1dd03;
}
@media (max-width: 1500px) {
    .modal-body-content{
        flex-direction: column;
    }
    .reper-info{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin: 0 0 0 auto;
    }
}
</style>
